import { useState } from "react";
import { Navbar } from "../components/Navbar";
import { Hero } from "../components/Hero";
import { MarqueeTicker } from "../components/MarqueeTicker";
import { Manifesto } from "../components/Manifesto";
import { GameCatalog } from "../components/GameCatalog";
import { EquipmentShowcase } from "../components/EquipmentShowcase";
import { PricingSection } from "../components/PricingSection";
import { BookingFlow } from "../components/BookingFlow";
import { LocationContact } from "../components/LocationContact";
import { Footer } from "../components/Footer";
import { scrollToId } from "../hooks/useLenis";

export default function LandingPage() {
  const [preset, setPreset] = useState(null);
  const reserve = (data = {}) => {
    setPreset({ ...data, ts: Date.now() });
    scrollToId("#reservation");
  };
  return (
    <div data-testid="landing-page">
      <Navbar onReserve={() => reserve()} />
      <main>
        <Hero onReserve={() => reserve()} />
        <MarqueeTicker />
        <GameCatalog
          onReserve={(exp) => reserve({ experience: exp.slug, machine: exp.machine })}
        />
        <Manifesto />
        <EquipmentShowcase />
        <PricingSection onReserve={(p) => reserve(p)} />
        <BookingFlow preset={preset} />
        <LocationContact />
      </main>
      <Footer />
    </div>
  );
}
